import { Tag } from 'antd';
import React from 'react';
import getFormattedDate from './getFormattedDate';
import { DATE_TIME_FORMAT } from '../const/system';
import IntlMessages from '../layout/components/lang/IntlMessages';



export const renderDatetimeColumnWithUtcZeroTimeBool = (value, item) => {
  return (
    <>
      <div>{getFormattedDate(value, DATE_TIME_FORMAT)}</div>
      <div>
        {item.use_utc_zero_time ? (
          <Tag color='default'><IntlMessages id="features-utc" /></Tag>
        ) : ''}
      </div>
    </>
  );
};
